// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NewerStatusMap: any = {
  '2': '',
  '3': '领取',
  '4': '已完成',
  '5': '已结束',
};

export { NewerStatusMap };

export enum CurrencySymbol {
  USD = '$',
  CNY = '¥',
  VND = '₫',
  INR = '₹',
  BRL = 'R$',
  IDR = 'Rp',
  EUR = '€',
  RUB = '₽',
  JPY = '￥',
  THB = '฿',
  TWD = 'NT$',
  HKD = 'HK$',
}
